import { useEffect, useRef, useState } from 'react'
import { useParams, useNavigationType, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'

//styles
import './property-details/styles/property-details.css'

//images
import LocationImage from '../images/location.png'
import InfoIcon from '../images/info-1.svg'


//componentes
import ContentWrapper from './assets/elements/content-wrapper'
import Loading from './assets/controls/loading'
import Gallery from './property-details/gallery'
import FloorPlans from './property-details/floor-plans'
import Price from './property-details/price'
import Renovation from './property-details/renovation/renovation'
import Information from './assets/elements/information'
import Amenities from './property-details/amenities/amenities'
import Reviews from './property-details/reviews'
import Location from './property-details/location'
import Recommendations from './property-details/recommendations'
import Title from './property-details/title'
//utils
import { setPropertyDetails } from '../utils/property-details'
import { getPrimaryPropertyImage } from '../utils/files'

//action
import { setRecommendedPropertiesData } from '../actions/property-details'

//constant
import { MESSAGE_NO_DATA } from '../constant/messages'
import { SHOW_RATES } from '../constant/settings'
import * as React from 'react'

const PropertyDetails = ({ recommendedProperties, propertyDetails, loading, loadingRecommendedProperties, setRecommendedPropertiesData, isPropertyAddedToCart }) => {
  const navigate = useNavigate();
  const browserHistoryType = useNavigationType()
  const [prevParams, setPrevParams] = useState(null)

  const [localFloorPlans, setLocalFloorPlans] = useState([])
  const [propertyImages, setPropertyImages] = useState([])

  const params = useParams()
  const location_area = useRef()
  const section1_height = useRef(null)
  const [maxHeight, setMaxHeight] = useState(0)

  const scrollToElement = reference => window.scrollTo(0, reference.current.offsetTop - 90)

  const handleResize = _ => {
    if (section1_height?.current) {
      const resizeObserver = new ResizeObserver(() => {
        setMaxHeight(section1_height?.current?.offsetHeight)
      })
      resizeObserver?.observe(section1_height?.current)
      return () => resizeObserver?.disconnect()
    }
  }

    const goBackToSearch = () => {
        navigate('/property-search');
    }

  useEffect(() => {
    const BeforeUnloadHandler = _ => {
      sessionStorage.setItem('isRefreshingDetails', true)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('beforeunload', BeforeUnloadHandler)
    return () => {
      window.removeEventListener('beforeunload', BeforeUnloadHandler)
      window.removeEventListener('resize', handleResize)

    }
  }, [])

  useEffect(() => {
    handleResize()
  }, [loading])


  useEffect(() => {
    if (browserHistoryType === 'PUSH' || sessionStorage.getItem('isRefreshingDetails') === 'true' || (prevParams && prevParams !== params.id) || Object.keys(propertyDetails)?.length <= 0) {
      setPropertyDetails(params.id, navigate)
      sessionStorage.getItem('isRefreshingDetails') && sessionStorage.setItem('isRefreshingDetails', false)
      setRecommendedPropertiesData()
    }
    window.history.scrollRestoration = 'manual'
    setPrevParams(params.id)
  }, [params.id])

  useEffect(() => {
    const floorAllData = (propertyDetails?.supplierPropertyRates || [])
      .map(rate => {
        const floor = propertyDetails?.availableFloorPlans
          ?.find(f => f.id === rate.floorPlanTypeId);

        return {
          ...rate,
          name: floor?.name ?? null
        };
      })
      .filter(x => x.name);

    setLocalFloorPlans(floorAllData)
  }, [propertyDetails?.availableFloorPlans, propertyDetails?.supplierPropertyRates])

  useEffect(() => {
    if (propertyDetails?.propertyImages && propertyDetails?.propertyImages?.length > 0) {
      setPropertyImages(currentImages => [...currentImages, ...propertyDetails?.propertyImages])
    }
  }, [propertyDetails?.propertyImages])

  useEffect(() => {
    if (propertyDetails?.floorPlanImages && propertyDetails?.floorPlanImages?.length > 0) {
      setPropertyImages(currentImages => [...currentImages, ...propertyDetails?.floorPlanImages])
    }
  }, [propertyDetails?.floorPlanImages])

  return (
    <ContentWrapper>
      {!loading && 
              <div>
                  {propertyDetails?.active ?
                      <React.Fragment>
                          <div>
                              <Title id={propertyDetails?.id} name={propertyDetails?.name} companyName={propertyDetails?.companyName} type={propertyDetails?.buildingTypeName} renovated={propertyDetails?.recentlyRenovated} renovatedDate={propertyDetails?.dateOfRenovation} isOasisCertified={propertyDetails?.isOasisCertified} />
                              <div className='property-details__address-section'>
                                  {propertyDetails?.address && propertyDetails?.address.formattedAddress && <a className='property-details-address' onClick={() => scrollToElement(location_area)}><img src={LocationImage} alt="" />{propertyDetails?.address.formattedAddress} (<span>Show on map</span>)</a>}
                                  {SHOW_RATES && <div className='details-title__price'>
                                      {propertyDetails?.rate && typeof propertyDetails?.rate === 'number' ? <div>from <span>${propertyDetails?.rate?.toFixed(2)}</span> / per night <img src={InfoIcon} alt="info_icon" /></div> : <div><span>On Request</span></div>}
                                      <div>Additional charges may apply</div>
                                  </div>}
                              </div>
                          </div>
                          <Gallery images={propertyImages} floorPlanSize={propertyDetails?.floorPlanImages?.length} propertiesSize={propertyDetails?.propertyImages?.length} />
                          <div className='property-details-multi-section'>
                              <div className='property-details-multi-section__section1' ref={section1_height}>
                                  <Information title='Description'>{propertyDetails?.description ? propertyDetails?.description : MESSAGE_NO_DATA}</Information>
                                  {propertyDetails?.recentlyRenovated && <Renovation rdate={propertyDetails?.dateOfRenovation} rdetails={propertyDetails?.renovationDetails} />}
                                  <Amenities data={propertyDetails?.amenities} petsAllowed={propertyDetails?.petsAllowed} />
                                  <Information title='Terms'>{propertyDetails?.terminationPolicy ? propertyDetails?.terminationPolicy : "Provided on Request"}</Information>
                                  {propertyDetails?.availableFloorPlans?.length > 0 && propertyDetails?.availableFloorPlans?.length > 0 && localFloorPlans?.length > 0 && <Price floors={propertyDetails?.availableFloorPlans} data={localFloorPlans} isViewOnly={propertyDetails?.isViewOnly } />}
                              </div>
                              {propertyDetails?.propertyReviews?.length > 0 &&
                                  <div className='property-details-multi-section__section2'>
                                      <Reviews maxHeight={maxHeight} data={propertyDetails?.propertyReviews} />
                                  </div>
                              }
                          </div>
                          <div>
                              {propertyDetails?.floorPlanImages?.length > 0 && <FloorPlans data={propertyDetails?.floorPlanImages} />}
                              <div ref={location_area}>
                                  <Location latitude={propertyDetails?.address?.latitude} longitude={propertyDetails?.address?.longitude} name={propertyDetails?.name} />
                              </div>
                          </div>
                      </React.Fragment>
                      :
                      <React.Fragment>
                          <div className="property-details__inactive">
                              <div className="property-details--info-section__inactive">
                                  <div className="inactive-property section-title">The property #{propertyDetails?.id} is no longer available</div>
                                  <div className="inactive-property__text">It looks like this property is no longer active on our platform. We apologize for any inconvenience. </div>
                                  <div className="inactive-property__options">You may:
                                      <div className="inactive-property__option option-link" onClick={goBackToSearch}>Go back to search results and choose another property in this location</div>
                                      <div className="inactive-property__option">Choose one of the properties below</div>
                                  </div>
                              </div>
                              <div className="property-details--image-section__inactive">
                                  <div className="property-details-image__inactive-section">
                                      <img src={getPrimaryPropertyImage(propertyDetails?.id, 2)} alt={`Property Image #${propertyDetails?.id}`} loading="lazy" />
                                      <div className="property-details-image__inactive-text">Not Available</div>
                                  </div>
                              </div>
                          </div>
                         
                      </React.Fragment>
                  }
                  <Recommendations data={recommendedProperties} isLoading={loadingRecommendedProperties} />
        </div>
      }
      {/* {Object.keys(propertyDetails || {})?.length <= 0 && !loading && !loadingRecommendedProperties &&
        <Message>{MESSAGE_ERROR}</Message>
      } */}
      <div className='property-details-loading'><Loading isVisble={loading} /></div>
    </ContentWrapper>
  )
}
function mapStateToProps({ details }) {
  return {
    propertyDetails: details.propertyDetails,
    loading: details.loading,
    loadingRecommendedProperties: details.loadingRecommendedProperties,
    recommendedProperties: details.recommendedProperties,
    isPropertyAddedToCart: details.isPropertyAddedToCart
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setRecommendedPropertiesData: () => dispatch(setRecommendedPropertiesData([])),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PropertyDetails)